/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Card, Flex } from '@radix-ui/themes';

import { use } from 'fierry/react';

import Time from 'solis/time';

import BoardRanges from 'solis/logic/board/ranges';

import Section from 'solis/claude/primitive/section';

import ScoreProgress from 'solis/claude/card/authority/progress';
import AuthorityRows from 'solis/claude/card/authority/rows';


const getNowAfterBoardCreation = (board, now) =>
{
  return Math.max(now, board.cass.createDate);
};


const Component = ({ board, colonies, now }) =>
(
  <Card>
    <Flex direction = 'column' gap = '3'>

      <Section label = 'Authority' gap = '1'>

        <ScoreProgress board = {board} now = {now} />

        <Flex direction = 'column' gap = '1' mt = '2'>
          <AuthorityRows board = {board} colonies = {colonies} now = {now} />
        </Flex>

      </Section>

    </Flex>
  </Card>
);


export default ({ board, account }) =>
{
  const now = use(Time);

  const colonies = BoardRanges.of(board).getColoniesByAccount(account);

  return colonies.length ? <Component board = {board} colonies = {colonies} now = {getNowAfterBoardCreation(board, now)} /> : null;
};
